module.exports = __webpack_public_path__ + "static/media/works5.6658b0b8.png";